import { render, staticRenderFns } from "./SolicitudEmpresas.vue?vue&type=template&id=53b1f00e"
import script from "./SolicitudEmpresas.vue?vue&type=script&lang=js"
export * from "./SolicitudEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports